import styles from './Marker.module.scss'

import { Marker as BaseMarker } from 'maplibre-gl'

/**
 * A simple map marker.
 */
export default class Marker {

    /** @type {import("maplibre-gl").Marker} */
    _marker

    /**
     * @param {Object} lngLat
     * @param {HTMLElement} element
     * @param {number[]} [offset]
     */
    constructor(lngLat, element, offset) {
        this._marker = new BaseMarker(element ? { element, offset } : element).setLngLat(lngLat)
    }

    /**
     * Add this marker to a map.
     * @param {import("../maps").Map|import("maplibre-gl").Map} map The map this marker should be added to
     */
    addTo(map) {
        this._marker.addTo(map)
    }

    /**
     * Remove this marker from the current map.
     */
    remove() {
        this._marker.remove()
    }

    /**
     * Add an event listener to the markers outer DOM element.
     * @param {string} type
     * @param {(e: Event) => void} handler
     */
    addEventListener(type, handler) {
        this._marker.getElement().addEventListener(type, handler)
    }

    /**
     * @param {"full"|"faded"|"transparent"} type
     */
    setOpacity(type) {
        const el = this._marker.getElement()
        el.classList.remove(styles.faded, styles.transparent)
        if (type === 'faded') {
            el.classList.add(styles.faded)
        } else if (type === 'transparent') {
            el.classList.add(styles.transparent)
        }
    }

    /**
     * Set position of current marker.
     * @param {Object} lngLat
     */
    setLngLat(lngLat) {
        this._marker.setLngLat(lngLat)
    }

    // Forward classList of outer element
    get classList() { return this._marker.getElement().classList }

}
